"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a given prop exists on an Object
 */
function hasOwn(obj, key) {
    return {}.hasOwnProperty.call(obj || {}, key);
}
exports.default = hasOwn;
//# sourceMappingURL=hasOwn.js.map